import { sendTrackingEvent } from 'h-commons';
import React from 'react';
import RocketIcon from '../images/rocket-upgrade.svg';
import SessionedLink from './SessionedLink';
import SVGInline from 'react-svg-inline';
import { Button } from '@hiver/hiver-ui-kit';

const UpgradeHookScreen = (props) => {
    const { header, content, footer, link, wrapperStyle = {}, upgradeClickedEvent = null } = props;
    return (
        <div style={{ ...styles.wrapper, ...wrapperStyle }}>
            {header || <SVGInline svg={RocketIcon} width="138" height="138" />}
            {typeof content === 'string' ? (
                <div style={styles.content}>{content}
                { link && <a href={link} target="_blank">{"here"}</a>}</div>
            ) : (
                content
            )}
            {footer || (
                <SessionedLink to="/app/settings/account/upgrade">
                    <Button
                        className="delete-btn"
                        color="tertiary"
                        size="large"
                        onClick={() => upgradeClickedEvent && sendTrackingEvent(upgradeClickedEvent)}
                        sx={{fontSize:'14px'}}>
                    UPGRADE
                    </Button>
                </SessionedLink>
            )}
        </div>
    );
};

const styles = {
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: '10vh',
        WebkitFontSmoothing: 'antialiased',
    },
    content: {
        maxWidth: '442px',
        fontFamily: '"Open Sans", sans-serif',
        fontSize: '13px',
        fontWeight: '400',
        textAlign: 'center',
        color: "#343C45",
        lineHeight: '24px',
        margin: '0 0 25px 0',
    },
};

export default UpgradeHookScreen;
